import React, { useContext } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Container } from 'react-bootstrap';
import HomeContext from '../../../routes/context/homeContext';
import { api, homepageUploadDir } from '../../../config';
import { getDynamicTitleByLocale, getDynamicTitleByName } from '../../../helpers/getDynamicTitle';
import CategorySearch from '../CategorySearch/CategorySearch';
import HomeSkeleton from '../../Skeleton/Home/HomeSkeleton/HomeSkeleton';
import s from './HomeSection.css';


const HomeSection = ({ currentLocale, dynamicHomePageSettings, skeletonLoading, siteName }) => {
  const homepage = useContext(HomeContext);
  const apiEndpoint = api && api.apiEndpoint;

  const allHomeSectionTitle = getDynamicTitleByName({ dynamicHomePageSettings, name: 'homeSectionTitle1' });
  let homeSectionTitle = getDynamicTitleByLocale({ dynamicHomePageSettings: allHomeSectionTitle, locale: currentLocale });

  homeSectionTitle = homeSectionTitle?.length > 0 ? homeSectionTitle[0] : allHomeSectionTitle[0];

  if (skeletonLoading) {
    return (
      <HomeSkeleton />
    )
  }
  else {
    return (
      <div
        className={s.homeSectionBannerBg}
        style={{
          backgroundImage: `url(${apiEndpoint}${homepageUploadDir}${homepage.homeSectionImage1})`,
        }}
      >
        <Container>
          <div className={s.bannerSectionRow}>
            <div className={s.bannerContentSection}>
              <h1 className={s.bannerHeading}>{homeSectionTitle?.value}</h1>
              <p className={s.homeBannerPara}>
                <span className={s.homeBannerSpecialText}>{siteName}</span>&nbsp;{homeSectionTitle?.description}
              </p>
              <CategorySearch isHomePage containerClass='homeBannerSearch' />
            </div>
            <div className={s.bannerImageSection}>
              <div className={s.bannerImageContainer}>
                <img
                  src={`${apiEndpoint}${homepageUploadDir}${homepage.homeSectionImage2}`}
                  alt=""
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    );
  }

};

export default withStyles(s)(HomeSection);
